import script from "./ManageBillingV1.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBillingV1.vue?vue&type=script&setup=true&lang=js"

import "./ManageBillingV1.vue?vue&type=style&index=0&id=1315e078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1315e078"]])

export default __exports__